/*
 * @Author: edvardchen
 * @Date:   2016-11-28 19:22:36
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:13:54
 */

import qs from 'query-string';
import urlUtil from './url';
import { isWeChat, isQQ, isAndroid, isIOS } from './UA';

import connection from './connection';

const reportType = {
  relive: 2,
  renew: 3,
  visit: 1,
};
const bid = 1013; // 分享中心分配的业务ID

export default function reportToShareCenter(type) {
  let src = '';
  const { userAgent } = window.navigator;
  if (isWeChat(userAgent)) {
    src = 'wx';
  } else if (isQQ(userAgent)) {
    src = 'qq';
  }
  let plat = '';
  if (isIOS(userAgent)) {
    plat = 3;
  } else if (isAndroid(userAgent)) {
    plat = 4;
  }

  const shareCount = Number(urlUtil.parse(window.location).query.share_count);
  const params = {
    bid,
    plat,
    src,
    share_count: shareCount || 1, // 上报分享计数
    etype: reportType[type],
  };
  return connection()
    .then(
      (netType) => {
        switch (netType) {
          case 'wifi':
            return 1;
          case '4g':
            return 2;
          default:
            return 3;
        }
      },
      () => 3,
    ) // resolve always
    .then((netType) => {
      params.netType = netType;
      const url = `https://sc.qq.com/fx/report?${qs.stringify(params)}`;
      new window.Image().src = url;
    });
}
